import React from 'react';
import {Route, Switch} from 'react-router';
import {Login} from './login';
import {Signup} from './signup';
import {ResetPassword} from './resetPassword';
import {Registration} from './registration';

export default () => {
  return (
    <Switch>
      <Route path="/signin">
        <Login />
      </Route>
      <Route path="/signup">
        <Signup />
      </Route>
      <Route path="/reset_password">
        <ResetPassword />
      </Route>
      <Route path="/registration">
        <Registration />
      </Route>
    </Switch>
  );
};
